import { useState } from "react";
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers/PickersDay";
import { Moment } from "moment";
import { Box, Tooltip, Typography } from "@mui/material";
import Api from "../../openapi";
import moment from "moment";
import {
  ChooseIcon,
  Copy3Icon,
  DeliveredIcon,
  LockIcon,
  OffIcon,
  PrepareIcon,
  Restaurant2Icon,
  RestaurantIcon,
  SelectedDisabledIcon,
  SelectedIcon,
} from "../../assets/icons";
import { CommonProps } from "@mui/material/OverridableComponent";
import { checkEmpty, checkIf, defaultFormat } from "../../utils";
import { MealTypeResponse, MenuBriefResponse } from "../../openapi/client";
import theme from "../../theme";
import { MonthlyCache } from "../../openapi/interfaces";
import { GraySpinner, MainSpinner } from "../Spinner";
import { RootState } from "../../store";
import { useSelector } from "react-redux";
import Can from "../Can";

export default function CustomDay(
  props: PickersDayProps<Moment> & {
    lockedStart?: Moment;
    daysinfo?: MonthlyCache;
    selectedPlan?: string;
    mealTypes?: MealTypeResponse[];
    loading?: boolean;
    onCloneSelect?: (day: Moment) => void;
  }
) {
  const [menuItems, setMenuItems] = useState<MenuBriefResponse>();
  const {
    day,
    outsideCurrentMonth,
    selectedPlan,
    mealTypes,
    daysinfo,
    loading,
    today,
    selected,
    lockedStart,
    ...other
  } = props;
  const currentDayInfo = daysinfo?.[day.format(defaultFormat)];
  const readOnlyMode = day.isBefore(moment.utc(lockedStart));
  const past = day.isBefore(moment().startOf("day"));

  const className = `${selected ? "selected" : ""} ${today ? "today" : ""} ${past ? "past" : ""}`;

  // console.log("day", day);
  // console.log("day of month", day.format("D"));
  // console.log("selectedPlan", selectedPlan);
  // console.log("props.daysInfo", daysinfo);
  //   const isSelected = !props.outsideCurrentMonth && highlightedDays.indexOf(props.day.date()) >= 0;
  //   const status = props.daysinfo?.find((info: any) => info.date === props.day.format(defaultFormat))
  //     ?.status as PlanDayResponseStatusEnum;

  const handleDaySelect = (day: Moment) => {
    // if there is no items in a past date, return
    if (past && !currentDayInfo?.items?.length) return;

    props.onDaySelect(day);
  };

  const clone = (e: React.MouseEvent, day: Moment) => {
    e.stopPropagation();
    e.preventDefault();
    props.onCloneSelect && props.onCloneSelect(day);
  };

  //   const { icon, className, explanation } = getStatusInfo(status);
  // const firstDayOfWeek = day.weekday() === 0;

  return (
    <PickersDay
      key={props.day.format(defaultFormat)}
      {...other}
      className={className}
      disableMargin
      outsideCurrentMonth={outsideCurrentMonth}
      day={day}
      onDaySelect={handleDaySelect}
      sx={{
        "&.today > span.MuiTypography-root": { border: "2px solid #FF8F0B" },
        "&.selected": { backgroundColor: "rgba(19, 111, 215, 0.06)" },
        "&.past": { backgroundColor: "rgba(0, 0, 0, 0.02)" },
      }}
    >
      <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#000", lineHeight: "normal" }} component={"span"}>
        {day.format("D")}
      </Typography>
      {loading ? (
        <GraySpinner />
      ) : checkEmpty(selectedPlan) ? (
        <Box
          sx={{ display: "flex", flexDirection: "column", gap: "8px", justifyContent: "center", alignItems: "center" }}
        >
          <LockIcon color={theme.palette.text.red} />
          <Typography sx={{ color: "text.red", fontSize: "12px", fontWeight: 500, lineHeight: "20px" }}>
            Please select a Plan
          </Typography>
        </Box>
      ) : currentDayInfo?.items?.length ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: "4px", flexWrap: "wrap", padding: "0 12px" }}>
          {currentDayInfo.items.map((item) => (
            <Tooltip
              key={item.type}
              title={
                <>
                  {item.meals?.length ? (
                    <Box sx={{ display: "flex", flexWrap: "nowrap", flexDirection: "column", gap: "4px" }}>
                      {item.meals?.map((meal, key) => (
                        <Typography sx={{ fontSize: "12px" }} key={key}>
                          {meal}
                        </Typography>
                      ))}
                    </Box>
                  ) : (
                    "No meals"
                  )}
                </>
              }
              placement="top"
              arrow
            >
              <Typography
                key={item.type}
                sx={{
                  background: "#EEEFF0",
                  borderRadius: "4px",
                  padding: "0px 6px",
                  color: "text.dark2",
                  fontSize: "10px",
                  fontWeight: 500,
                  lineHeight: "180%",
                }}
              >
                {mealTypes?.find((type) => type.name === item.type)?.description || item.type}
              </Typography>
            </Tooltip>
          ))}
        </Box>
      ) : readOnlyMode ? (
        <Box
          sx={{ display: "flex", flexDirection: "column", gap: "8px", justifyContent: "center", alignItems: "center" }}
        >
          <Restaurant2Icon color={theme.palette.text.blue} />
          <Typography sx={{ color: "text.blue", fontSize: "12px", fontWeight: 500, lineHeight: "20px" }}>
            No Meal
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            justifyContent: "center",
            alignItems: "center",
            padding: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "8px",
              padding: "8px",
              borderRadius: "8px",
              alignItems: "center",
              background: "rgba(55, 189, 107, 0.08)",
              "&:hover": { background: "rgba(55, 189, 107, 0.18)" },
            }}
          >
            <RestaurantIcon color={theme.palette.primary.main} />
            <Typography sx={{ color: "primary.main", fontSize: "12px", fontWeight: 600, lineHeight: "20px" }}>
              Click to Add Meal
            </Typography>
          </Box>

          <Can permission="MEAL_PLANNING_CREATE">
            <Box
              onClick={(e) => clone(e, day)}
              sx={{
                display: "flex",
                gap: "8px",
                padding: "8px",
                borderRadius: "8px",
                alignItems: "center",
                background: "rgba(255, 143, 11, 0.08)",
                "&:hover": { background: "rgba(255, 143, 11, 0.18)" },
              }}
            >
              <Copy3Icon color={theme.palette.tertiary.main} />
              <Typography sx={{ color: "tertiary.main", fontSize: "12px", fontWeight: 600, lineHeight: "20px" }}>
                Clone from Another Period
              </Typography>
            </Box>
          </Can>
        </Box>
      )}
    </PickersDay>
  );
}
